<section class="container-section" *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" [formGroup]="formInvoiceFirst">
        <div class="ps-2 pe-2">
          <div class="row pt-1">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                [width]="'6rem'" (onClick)="close()" [severity]="null"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>
            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <!-- Información adicional -->
              <app-custom-button [hidden]="previewInvoice" [title]="'Información adicional'"
                [icon]="'pi pi-info-circle'" [severity]="'contrast'"
                (onClick)="openInvoiceInformation()"></app-custom-button>

              <app-custom-modal #invoiceInformation [label]="'Información Factura'" [header]="'Información Factura'"
                [inputs$]="inputsForInvoiceInformation$" [children]="componentInvoiceInformation" [width]="'45vw'"
                [closable]="false" (params)="reloadInvoice($event)" hidden>
              </app-custom-modal>

              <!-- Copiar factura -->
              <app-custom-button [hidden]="previewInvoice" [title]="'Copiar desde'" [severity]="'contrast'"
                [icon]="'pi pi-copy'" (onClick)="openCopyInvoice()"></app-custom-button>

              <app-custom-modal #copyInvoice [label]="'Copiar Factura'" [header]="'Copiar Factura'"
                [inputs$]="inputsForCopyInvoice$" [children]="componentCopyInvoice" [width]="'20vw'"
                [breakpoints]="breakpointsForCopy" [closable]="true" (params)="reloadInvoice($event)" hidden>
              </app-custom-modal>

              <!-- Adjuntar archivos -->
              <app-custom-button [title]="'Adjuntar archivos'" [icon]="'pi pi-paperclip'" [severity]="'contrast'"
                (onClick)="openAttachFile()"></app-custom-button>

              <app-custom-modal #attachFileInvoice [header]="'Adjuntar archivos'" [children]="componentAttachFiles"
                [closable]="true" [width]="'40vw'" [inputs$]="inputsForAttachFiles$" [output$]="outputForAttachFiles$"
                hidden></app-custom-modal>

              <!-- Vista previa -->
              <app-custom-button [title]="titlePreviewInvoice" [icon]="iconPreviewInvoice" [severity]="'contrast'"
                (onClick)="openPreviewInvoice()"></app-custom-button>

              <!-- Exportar excel -->
              <app-custom-button *ngIf="previewInvoice" [title]="'Exportar excel'" [severity]="'contrast'"
                [icon]="'pi pi-file-excel'" (onClick)="exporterDetailsPreview()"></app-custom-button>

              <!-- Imprimir -->
              <app-custom-button [hidden]="invoiceContract.invoiceId == 0" [title]="'Imprimir'" [severity]="'contrast'"
                [icon]="'pi pi-print'" (onClick)="openPrintRange()"></app-custom-button>

              <app-custom-modal #printRange [label]="'Imprimir'" [header]="'Imprimir'" [inputs$]="inputsForPrintRange$"
                [children]="componentPrintRange" [width]="'30vw'" [closable]="true" (params)="getParamsPrint($event)"
                hidden>
              </app-custom-modal>

              <!-- Eliminar -->
              <app-custom-button [hidden]="previewInvoice" [title]="'Eliminar'" [severity]="'contrast'"
                [icon]="'pi pi-trash'" (onClick)="deleteInvoice()"></app-custom-button>

              <!-- NUEVO -->
              <app-custom-button [hidden]="previewInvoice" class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'"
                [icon]="'pi pi-plus'" (onClick)="createNewInvoice()" [severity]="'success'" [width]="'5.5rem'"
                [variant]="undefined"></app-custom-button>
            </div>
            <hr class="my-1">
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="invoiceContract.userNameCreate"
                [createDate]="invoiceContract.createDate" [userNameUpdate]="invoiceContract.userNameUpdate"
                [updateDate]="invoiceContract.updateDate"
                [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
          <div [hidden]="previewInvoice">
            <!-- Formulario Captura -->
            <div class="row mt-1 d-flex justify-content-between">
              <div class="col-lg-8 col-md-12 col-sm-12 col-12 pe-lg-5 pe-md-2">
                <div class="row">
                  <div class="custom-container col-lg-4 col-md-2 col-sm-6 col-12">
                    <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                      [required]="true" [recovery]="true"
                      (onChangeSelect)="getBranch($event, true)"></app-custom-select>
                  </div>
                  <div class="custom-container col-lg-4 col-md-2 col-sm-6 col-12">
                    <app-custom-select formControlName="enterpriseId" [labelText]="'Empresa'" [list]="listEnterprises"
                      [required]="true" [recovery]="true"
                      (onChangeSelect)="getEnterprise($event, true)"></app-custom-select>
                  </div>
                  <div class="custom-container col-lg-2 col-md-2 col-sm-4 col-6">
                    <app-custom-select formControlName="bussinessDocumentsTypeId" [labelText]="'Tipo'"
                      [list]="listBussinessDocumentsTypes" [required]="true" [recovery]="true"
                      (onChangeSelect)="getBussinessDocumentsType($event, true)"></app-custom-select>
                  </div>
                  <div class="custom-container col-lg-2 col-md-2 col-sm-2 col-6">
                    <app-custom-input-number formControlName="consecutive" [labelText]="'Número'" [required]="true"
                      [recovery]="true" (onChangeNumber)="changeConsecutive()"></app-custom-input-number>
                  </div>
                  <div class="custom-container col-lg-2 col-md-2 col-sm-3 col-6">
                    <app-custom-datepicker formControlName="dateInvoice" [labelText]="'Fecha'" [required]="true"
                      (onChangeDate)="validatePeriodDate()"></app-custom-datepicker>
                  </div>
                  <div class="custom-container col-lg-2 col-md-2 col-sm-3 col-6">
                    <app-custom-datepicker formControlName="dateExpiration" [labelText]="'Vencimiento'"
                      [required]="true" (onChangeDate)="validateDateExpiration()"></app-custom-datepicker>
                  </div>
                  <div class="custom-container col-lg-4 col-md-6 col-sm-6 col-12">
                    <app-custom-autocomplete formControlName="clientId" [labelText]="'Cliente'" [list]="listClients"
                      [required]="true" [class]="getClass('client')" (onChangeSelect)="getClient($event, true)">
                    </app-custom-autocomplete>
                  </div>
                  <div class="custom-container col-lg-4 col-md-6 col-sm-6 col-12">
                    <app-custom-autocomplete formControlName="costCenterId" [labelText]="'C.Costos'"
                      [list]="filteredCostCenters" [class]="getClass('costCenter')"
                      (onChangeSelect)="getCostCenter($event, true)">
                    </app-custom-autocomplete>
                  </div>
                  <div class="custom-container col-lg-8 col-md-9 col-sm-12 col-12">
                    <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [autoResize]="false"
                      [rows]="1" [maxLength]="250"></app-custom-textarea>
                  </div>
                  <div *ngIf="swSalesRemission" class="custom-container col-lg-2 col-md-3 col-sm-6 col-6">
                    <app-custom-select class="flex-grow-1" formControlName="settlementType"
                      [labelText]="'Tipo Liquidación'" [required]="true" [list]="listSettlementTypes"
                      (onChangeSelect)="getSettlement($event)">
                    </app-custom-select>
                  </div>

                </div>
              </div>
              <div class="col-lg-4 col-md-12 col-sm-12 col-12 ps-md-2 pt-lg-0 pt-sm-2">
                <div class="row">
                  <div class=" col-lg-3 col-md-2 col-sm-2 col-6">
                    <app-custom-tag [label]="'Estado'" [severity]="severityState"
                      [value]="invoiceStateString"></app-custom-tag>
                  </div>
                  <div class="col-lg-3 col-md-2 col-sm-2 col-6 d-flex align-items-end gap-1">
                    <app-custom-button [title]="titleStateInvoice" [icon]="iconStateInvoice"
                      [disabled]="this.invoiceContract.swBlock" (onClick)="changeStateInvoice()"></app-custom-button>
                    <app-custom-checkbox class="mb-1" formControlName="swBlock" [labelText]="'Bloq.'"
                      (onChangeCheckBox)="blockInvoice($event)"></app-custom-checkbox>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-8 col-12 d-flex justify-content-lg-end mt-2 my-lg-0">
                    <div class="d-lg-grid d-flex align-items-end gap-1 me-2">
                      <app-custom-checkbox formControlName="enterpriseSwSelfRetainer"
                        [labelText]="'Auto.Rt.Fte.'"></app-custom-checkbox>
                      <app-custom-checkbox formControlName="enterpriseSwIcaSelfRetainer"
                        [labelText]="'Auto.Rt.Ica.'"></app-custom-checkbox>
                    </div>
                    <div class="d-lg-grid d-flex align-items-end gap-1">
                      <app-custom-chip [label]="'Corte: ' + invoicingCutoffCode" />
                      <app-custom-chip [label]="'Fra.Elec: ' + electronicInvoiceInterfaceCode" />
                    </div>
                  </div>
                  <div class="custom-container col-lg-4 col-md-3 col-sm-4 col-4 mt-1">
                    <app-custom-input-text formControlName="purchaseOrder" [labelText]="'Orden Comp.'"
                      [maxLength]="20"></app-custom-input-text>
                  </div>
                  <div class="custom-container col-lg-4 col-md-3 col-sm-4 col-4 mt-1">
                    <app-custom-input-text formControlName="approvalNumber" [labelText]="'Nro. Aprob.'"
                      [maxLength]="20"></app-custom-input-text>
                  </div>
                  <div class="custom-container col-lg-4 col-md-3 col-sm-4 col-4 mt-1">
                    <app-custom-input-text formControlName="remission" [labelText]="'Remisión'"
                      [maxLength]="20"></app-custom-input-text>
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 col-12 m-top d-flex justify-content-end">
                    <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [disabled]="disabledForm"
                      [variant]="undefined" (onClick)="send()"></app-custom-button>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <!-- Vista Previa -->
          <div *ngIf="previewInvoice">
            <app-custom-progress-bar [show]="visibleLoading" [heightProgress]="'0.3rem'"></app-custom-progress-bar>
            <div class="d-flex justify-content-center mt-2">
              <div id="container-format" [hidden]="visibleLoading">
                <app-print-invoice id="preview-invoice" [companyId]="companyId" [formatModel]="formatModel"
                  [invoiceModels]="invoicesPrintModel" [exporterInvoiceDetailsPreview]="exporterInvoiceDetailsPreview"
                  [invoiceTraffic]="'Vista Previa'" [editFormat]="false" [focusText]="false"
                  (finishLoadingPrintInvoice)="visiblePreview($event)">
                </app-print-invoice>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div [hidden]="previewInvoice">
        <p-accordion [(value)]="activePanel" value="none" class="accordion-detail" [transitionOptions]="'0ms'"
          (onClose)="toggleAccordion()" (onOpen)="toggleAccordion()">
          <p-accordion-panel value="0">
            <p-accordion-header>
              <div class="d-flex align-items-center gap-2 w-100">
                <span class="flex-grow-1"> Detalle de la factura ({{quantityDetails}}) </span>
                <div class="mx-3 d-flex gap-2" (click)="$event.stopImmediatePropagation()"
                  (mousedown)="$event.stopImmediatePropagation()">
                  <!-- Remisión venta -->
                  <app-custom-button *ngIf="swSalesRemission" [title]="'Liquidación'" [label]="'Liquidación'"
                    [icon]="'pi pi-dollar'" [width]="'6.2rem'" [disabled]="disableSettlementButton"
                    (onClick)="openSettlementModal()">
                  </app-custom-button>
                  <app-custom-modal #settlement [header]="'Selección de Remisiones de Venta'"
                    [inputs$]="inputsForSettlementModals$" [children]="componentSettlement" hidden [output$]="output$"
                    (params)="refreshInvoiceData($event)">
                  </app-custom-modal>
                  <!-- Detalle -->
                  <app-custom-button [label]="'Nuevo Detalle'" [severity]="'success'" [width]="'7rem'"
                    [disabled]="disabledForm" (onClick)="clicNewDetail($event)">
                  </app-custom-button>
                </div>
              </div>
            </p-accordion-header>
            <p-accordion-content>
              <div class="row detail-container container-detail" [hidden]="invoiceContract.invoiceId == 0"
                *ngIf="showAccordion">
                <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                  <app-invoice-detail #invoiceDetail id="invoiceDetail" [invoiceModel]="invoiceContract"
                    [companyId]="companyId" [disabled]="disabledForm" [isFormView]="isFormView"
                    [defaultStoreIdForBranch]="defaultStoreIdForBranch" (updateInvoice)="getUpdateInvoice($event)">
                  </app-invoice-detail>
                </div>
              </div>
            </p-accordion-content>
          </p-accordion-panel>
        </p-accordion>
        <!-- Valores e impuestos de la factura -->
        <form class="needs-validation mt-1 container-style" [formGroup]="formInvoiceFooter">
          <div class="col-lg-12 col-12">
            <div class="row d-flex justify-content-between">
              <div class="col-12 col-lg-2">
                <div class="row">
                  <div class="custom-container col-lg-8 col-md-4 col-sm-8 col-8">
                    <app-custom-select formControlName="ivaTypeId" [labelText]="'Tipo IVA'"
                      [list]="listIvaTypes"></app-custom-select>
                  </div>
                  <div class="custom-container col-lg-4 col-md-4 col-sm-4 col-4">
                    <app-custom-input-decimal formControlName="administrationRate"
                      [labelText]="'Admin.'"></app-custom-input-decimal>
                  </div>
                </div>
                <div class="row">
                  <div class="custom-container col-lg-4 col-md-4 col-sm-4 col-4">
                    <app-custom-input-decimal formControlName="incidentalRate"
                      [labelText]="'Imprevistos'"></app-custom-input-decimal>
                  </div>
                  <div class="custom-container col-lg-4 col-md-4 col-sm-4 col-4">
                    <app-custom-input-decimal formControlName="utilityRate"
                      [labelText]="'Utilidad'"></app-custom-input-decimal>
                  </div>
                  <div class="custom-container col-lg-4 col-md-4 col-sm-4 col-4">
                    <app-custom-input-decimal [labelText]="'AIU'" [value]=totalAIU
                      [disabled]="true"></app-custom-input-decimal>
                  </div>
                </div>
              </div>
              <div class="col-lg-2 col-12">
                <div class="row">
                  <div class="custom-container col-lg-6 col-6">
                    <app-custom-input-decimal formControlName="debitNotesValue"
                      [labelText]="'Nota Débito'"></app-custom-input-decimal>
                  </div>
                  <div class="custom-container col-lg-6 col-6">
                    <app-custom-input-decimal formControlName="creditNotesValue"
                      [labelText]="'Nota Crédito'"></app-custom-input-decimal>
                  </div>
                </div>
                <div class="row">
                  <div class="custom-container col-lg-6 col-6">
                    <app-custom-input-decimal formControlName="paymentValue"
                      [labelText]="'Abonos'"></app-custom-input-decimal>
                  </div>
                  <div class="custom-container col-lg-6 col-6">
                    <app-custom-input-decimal formControlName="residueValue"
                      [labelText]="'Saldo'"></app-custom-input-decimal>
                  </div>
                </div>
              </div>
              <div class="col-lg-5 col-12">
                <div class="row">
                  <div class="custom-container col-lg-3 col-md-4 col-sm-4 col-6">
                    <app-custom-input-decimal formControlName="subtotalValue"
                      [labelText]="'Subtotal'"></app-custom-input-decimal>
                  </div>
                  <div class="custom-container col-lg-3 col-md-4 col-sm-4 col-6">
                    <app-custom-input-decimal formControlName="discountValue"
                      [labelText]="'Dcto Gral.'"></app-custom-input-decimal>
                  </div>
                  <div class="custom-container col-lg-3 col-md-4 col-sm-4 col-6">
                    <app-custom-input-decimal formControlName="ivaValue"
                      [labelText]="'Vr.Iva'"></app-custom-input-decimal>
                  </div>
                  <div class="custom-container col-lg-3 col-md-4 col-sm-4 col-6">
                    <app-custom-input-decimal formControlName="totalValue"
                      [labelText]="'Total'"></app-custom-input-decimal>
                  </div>
                  <div class="custom-container col-lg-3 col-md-4 col-sm-4 col-6">

                  </div>
                  <div class="custom-container col-lg-3 col-md-4 col-sm-4 col-6">
                    <app-custom-input-decimal formControlName="reteIvaValue"
                      [labelText]="'Rte.Iva'"></app-custom-input-decimal>
                  </div>
                  <div class="custom-container col-lg-3 col-md-4 col-sm-4 col-6">
                    <app-custom-input-decimal formControlName="reteFuenteValue"
                      [labelText]="invoiceContract.enterpriseSwSelfRetainer ? 'Auto.Rte.Fuente' : 'Rte.Fuente' "
                      [ngClass]="invoiceContract.enterpriseSwSelfRetainer ? 'text-danger' : ''">
                    </app-custom-input-decimal>
                  </div>
                  <div class="custom-container col-lg-3 col-md-4 col-sm-4 col-6">
                    <app-custom-input-decimal formControlName="reteIcaValue"
                      [labelText]="invoiceContract.enterpriseSwIcaSelfRetainer ? 'Auto.Rte.Ica' : 'Rte.Ica'"
                      [ngClass]="invoiceContract.enterpriseSwIcaSelfRetainer ? 'text-danger' : ''">
                    </app-custom-input-decimal>
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-12 col-lg-2">
                <div class="row">
                  <div class="discount-field col-lg-12 col-md-2 col-sm-4 col-6 d-flex justify-content-end">
                    <app-custom-button [label]="'Descuento'" [icon]="'pi pi-percentage'" [severity]="'success'"
                      [width]="'6.5rem'" (onClick)="openGeneralConcept()"></app-custom-button>

                    <app-custom-modal #generalDiscount [label]="'Descuento'" [header]="'Descuento por Concepto'"
                      [inputs$]="inputsForGeneralDiscount$" [children]="componentGeneralDiscount" [width]="'96vw'"
                      [closable]="false" [focusShow]="false" (params)="reloadInvoice($event)" hidden>
                    </app-custom-modal>
                  </div>
                  <div class="custom-container col-lg-12 col-md-10 col-sm-8 col-6">
                    <app-custom-tag [label]="'Vr. A Pagar'"
                      [value]="(invoiceContract.valueToPay | number:'1.2-2') + ' - ' + codeCurrency"></app-custom-tag>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
<!-- Imprimir Factura -->
<div id="container-print-invoice">
  <app-print-invoice *ngIf="printInvoiceFormat" id="print-invoice" [companyId]="companyId" [formatModel]="formatModel"
    [invoiceModels]="invoicesPrintModel" [invoiceTraffic]="invoiceTraffic" [editFormat]="false" [focusText]="false"
    (finishLoadingPrintInvoice)="finishLoading($event)">
  </app-print-invoice>
</div>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>